import type { RouteHandle } from 'src/root';
import type { LoaderFunctionArgs } from 'react-router';
import type { ServerRendered } from 'src/server/catalog.server';

import { useLocation, useLoaderData } from 'react-router';

import { useSession } from 'src/hooks/useSession';

import { loadListing } from 'src/server/listing.server';
import { RentalListing } from 'src/screens/RentalListing';

import { ServerAnswers } from 'src/components/ServerAnswers';

export const handle: RouteHandle = { serverRendered: true };

/** A car for rent, asked of the api by the server for the page it renders. */
export async function loader({ request, params }: LoaderFunctionArgs) {
  return loadListing(request, 'rental', params.id ?? '');
}

/** Every later visit is the browser's own: the screen asks the api itself, as it always did. */
export const clientLoader = () => null;

export default function RentalListingRoute() {
  const rendered = useLoaderData() as ServerRendered | null;
  const { isLoggedIn, account, hasLinkedWallet, isTMA, isPending } = useSession();
  // The dates in the address (`?start=&end=`, api#381) are read when the screen mounts: a new
  // query on the same car is a new screen, so the form starts from the new dates, not the old.
  const { search } = useLocation();

  return (
    <ServerAnswers rendered={rendered}>
      <RentalListing
        key={search}
        isLoggedIn={isLoggedIn}
        account={account}
        hasLinkedWallet={hasLinkedWallet}
        isTMA={isTMA}
        sessionPending={isPending}
      />
    </ServerAnswers>
  );
}
